import { SystemVariables } from "../modules"

export const SystemVariablesPage = () => {
  return (
    <SystemVariables />
  )
}
